import type { MaskConfig } from "./types";

/**
 * phone number mask (XXX-XXX-XXXX)
 * strips hyphens from the raw value
 */
export const phoneMask = (): MaskConfig => ({
  cleaveOptions: {
    numericOnly: true,
    blocks: [3, 3, 4],
    delimiter: "-",
  },
  placeholder: "XXX-XXX-XXXX",
  formatValue: (rawValue) => (rawValue ? rawValue.replace(/-/g, "") : ""),
});

/**
 * SSN mask (XXX-XX-XXXX)
 * strips hyphens from the raw value
 */
export const ssnMask = (): MaskConfig => ({
  cleaveOptions: {
    numericOnly: true,
    blocks: [3, 2, 4],
    delimiter: "-",
  },
  placeholder: "XXX-XX-XXXX",
  formatValue: (rawValue) => (rawValue ? rawValue.replace(/-/g, "") : ""),
});

/**
 * 5-digit ZIP code mask (XXXXX)
 */
export const zipcodeMask = (): MaskConfig => ({
  cleaveOptions: {
    numericOnly: true,
    blocks: [5],
  },
  placeholder: "XXXXX",
  formatValue: (rawValue) => rawValue,
});

/**
 * used in TIN
 * 4-digit ZIP code extension mask (XXXX)
 * Used for the +4 extension in ZIP+4 codes
 */
export const zipcodeFourMask = (): MaskConfig => ({
  cleaveOptions: {
    numericOnly: true,
    blocks: [4],
  },
  placeholder: "XXXX",
  formatValue: (rawValue) => rawValue,
});

/**
 * ZIP+4 code mask (XXXXX-XXXX)
 * strips hyphens if only 5 digits are entered
 */
export const zipcodeNineMask = (): MaskConfig => ({
  cleaveOptions: {
    numericOnly: true,
    blocks: [5, 4],
    delimiter: "-",
    delimiters: ["-"],
    delimiterLazyShow: true,
  },
  placeholder: "XXXXX-XXXX",
  formatValue: (rawValue) => {
    // if we only have 5 digits, remove the hyphen
    const cleanZip = rawValue.replace(/-/g, "");
    return cleanZip;
  },
});

/**
 * credit card mask - auto-detects card type and formats accordingly
 */
export const creditcardMask = (): MaskConfig => ({
  cleaveOptions: {
    creditCard: true,
  },
  placeholder: "XXXX XXXX XXXX XXXX",
  formatValue: (rawValue) => rawValue,
});

/**
 * medicare number mask (12 characters, alphanumeric)
 */
export const medicareMask = (): MaskConfig => ({
  cleaveOptions: {
    numericOnly: false,
    blocks: [12],
  },
  placeholder: "XXXXXXXXXXXX",
  formatValue: (rawValue) => rawValue,
});
